import React from "react";
import { Box, Divider, Paper, Skeleton, Stack } from "@mui/material";

const SubscriptionLoadingView = ({ paperBorderSx }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        ...paperBorderSx,
        p: { xs: 2.5, sm: 4 },
        mb: 3,
        flex: 1,
        minHeight: 400,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
      role='status'
      aria-label='Loading subscription details'
    >
      {/* Subscription header */}
      <Stack direction='row' alignItems='center' spacing={2}>
        <Skeleton
          variant='rounded'
          width={48}
          height={48}
          sx={{ borderRadius: 3, flexShrink: 0 }}
        />

        <Stack spacing={0.5} sx={{ flex: 1 }}>
          <Skeleton variant='text' width='40%' height={28} />
          <Skeleton variant='text' width='65%' height={20} />
        </Stack>
      </Stack>

      <Divider />

      {/* Subscription summary */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
          },
          gap: 2,
        }}
      >
        {[1, 2, 3, 4].map((item) => (
          <Box
            key={item}
            sx={{
              p: 2,
              border: 1,
              borderColor: "divider",
              borderRadius: 2,
            }}
          >
            <Skeleton variant='text' width='55%' height={18} />
            <Skeleton variant='text' width='75%' height={30} sx={{ mt: 1 }} />
            <Skeleton variant='text' width='45%' height={18} />
          </Box>
        ))}
      </Box>

      <Divider />

      {/* Billing details */}
      <Stack spacing={2}>
        <Skeleton variant='text' width='35%' height={26} />

        {[1, 2, 3].map((item) => (
          <Stack
            key={item}
            direction='row'
            justifyContent='space-between'
            alignItems='center'
          >
            <Skeleton variant='text' width='30%' height={20} />
            <Skeleton variant='text' width='25%' height={20} />
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};

export default SubscriptionLoadingView;
